import { useLocation, useNavigate } from "react-router-dom";
import CommonBreadcrumb from "../../components/CommonBreadcrumb";
import { useGetSubAdminByIdQuery } from "../../service/features/api";
import moment from "moment";

const SubadminDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id;

  const { data: subAdminData, isLoading } = useGetSubAdminByIdQuery(id, { skip: !id });

  

  if (isLoading) return <div className="loading_state">Loading...</div>;

  const data = subAdminData?.data;

  return (
    <>
      <CommonBreadcrumb
        title="Sub-Admin Detail" 
        breadcrumbItems={[
          { label: "Dashboard", onClick: () => navigate("/dashboard") },
          { label: "Manage Sub-Admin", onClick: () => navigate("/manage-subadmin") },
          { label: "Sub-Admin Detail" },
        ]}
      />

      <div className="cards view_page">
        <div className="gap_p">
          <div className="vew_img w_100">
            <h6>Image</h6>
            <figure>
              <img alt="user" src={data?.profile || "/static/images/user_placeholder.png"} />
            </figure>
          </div>
          <div className="w_33">
            <h6>Name</h6>
            <p>{data?.fullName || "N/A"}</p>
          </div>
          <div className="w_33">
            <h6>Email Id</h6>
            <p>{data?.email || "N/A"}</p>
          </div>
          <div className="w_33">
            <h6>Phone Number</h6>
            <p>{data?.countryCode} {data?.phone}</p>
          </div>
          <div className="w_33">
            <h6>Role</h6>
            <p>{data?.permission?.name || "N/A"}</p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>{data?.createdAt ? moment(data.createdAt).format("DD MMMM YYYY") : "N/A"}</p>
          </div>
        </div>

        {data?.permission?.permission && (
          <div className="permission_section" style={{ marginTop: '30px' }}>
            <h5 style={{ marginBottom: '15px' }}>Permissions</h5>
            <div className="table_container">
              <table className="table">
                <thead>
                  <tr>
                    <th>Module</th>
                    <th style={{ textAlign: 'center' }}>View</th>
                    <th style={{ textAlign: 'center' }}>Add</th>
                    <th style={{ textAlign: 'center' }}>Edit</th>
                    <th style={{ textAlign: 'center' }}>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {data.permission.permission.map((perm: any) => (
                    <tr key={perm._id}>
                      <td>{perm.label}</td>
                      <td style={{ textAlign: 'center' }}>{perm.isView ? "Yes" : "No"}</td>
                      <td style={{ textAlign: 'center' }}>{perm.isAdd ? "Yes" : "No"}</td>
                      <td style={{ textAlign: 'center' }}>{perm.isEdit ? "Yes" : "No"}</td>
                      <td style={{ textAlign: 'center' }}>{perm.isDelete ? "Yes" : "No"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SubadminDetail;
